'use es6';

import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getMenuTreeNode } from 'simple-menus-core/selectors/menuTree';
import MenuNodePreview from 'simple-menus-lib/components/dnd/preview/MenuNodePreview';
import MenuTreePreview from 'simple-menus-lib/components/dnd/preview/MenuTreePreview';
import { jsx as _jsx } from "react/jsx-runtime";
function makeMapStateToProps() {
  return function mapStateToProps(state, props) {
    return {
      nodes: [getMenuTreeNode(state, props)]
    };
  };
}
const mapDispatchToProps = {};
class MenuRootPreview extends PureComponent {
  constructor(props) {
    super(props);
    this.getMenuComponent = this.getMenuComponent.bind(this);
  }
  getMenuComponent(isNode) {
    return isNode ? MenuTreePreview : MenuNodePreview;
  }
  render() {
    return /*#__PURE__*/_jsx(MenuTreePreview, {
      nodes: this.props.nodes,
      getMenuComponent: this.getMenuComponent,
      depth: 0,
      parentId: this.props.parentId,
      menuId: this.props.menuId
    });
  }
}
MenuRootPreview.propTypes = {
  parentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  menuId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  nodes: PropTypes.arrayOf(PropTypes.object)
};
export default connect(makeMapStateToProps, mapDispatchToProps)(MenuRootPreview);